import { cs } from "@repo/ui";
import { type FC } from "react";
import * as Styled from "./PensionDpsMigrationBanner.styled";

export const PensionDpsMigrationBanner: FC = () => {
    return (
        <Styled.BannerWrapper>
            <Styled.ContentContainer>
                <Styled.HeadingContainer>
                    <Styled.HighlightedText>{cs.pensionDpsBanner.textLine11}</Styled.HighlightedText>
                    <Styled.InlineText>{cs.pensionDpsBanner.textLine12}</Styled.InlineText>
                    <Styled.HighlightedText>{cs.pensionDpsBanner.textLine13}</Styled.HighlightedText>
                    <Styled.InlineText>{cs.pensionDpsBanner.textLine14}</Styled.InlineText>
                </Styled.HeadingContainer>
            </Styled.ContentContainer>

            <Styled.ButtonContainer spacing={3}>
                <Styled.StyledButton
                    onClick={() => {
                        window.open("https://www.nn.cz/online-interni-prevod-penzijniho-sporeni.html?utm_source=prihlaseni.nn.cz&utm_medium=referral&utm_campaign=transfer", "_blank");
                    }}
                >
                    {cs.pensionDpsBanner.getMoreInfo}
                </Styled.StyledButton>
            </Styled.ButtonContainer>
        </Styled.BannerWrapper>
    );
};
